import Layout from "layouts";
import { serverGet } from "lib/serverRequest";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DeliveryZoneDetailComponent from "./DeliveryZoneDetailComponent";

export default function DeliveryZoneDetail() {
  const { regionId = "" } = useParams();
  const [deliveryZone, setDeliveryZone] = useState({});

  const loadData = () => {
    serverGet({
      url: `deliveryZone/${regionId}`,
      onFinish: (res, err) => {
        setDeliveryZone(res);
      },
    });
  };
  useEffect(() => {
    if (Boolean(regionId)) {
      loadData();
    }
    //eslint-disable-next-line
  }, [regionId]);

  return (
    <Layout
      breadCrumb={[
        { label: "Delivery Ticket", to: "/delivery-ticket" },
        {
          label: Boolean(regionId === "create")
            ? "Add New Delivery Zone"
            : `#${deliveryZone?.id}` ?? "",
          to: "#",
        },
      ]}
    >
      <DeliveryZoneDetailComponent
        regionId={regionId}
        deliveryZone={deliveryZone}
      />
    </Layout>
  );
}
